import { analyticsV4 } from '@cld/analytics';
import { AnalyticsEvents } from './analytics.constants';
import { parse } from 'picoquery';

export const getTopLevel = (url) => {
  const CLD_CONSOLE_RGX = /(dev|demo)?\.?cloudinary\.com$/;
  const { pmHost } = parse(url);
  return pmHost && String(pmHost).match(CLD_CONSOLE_RGX) ? 'assets' : 'modal';
};

const getLevels = (level3) => [getTopLevel(self.location.search), 'upload-widget', level3];

/**
 * Sends an analytics event for tab navigation.
 *
 * @param {string} tab - The clicked tab upload source of the tab navigation event.
 */
export const sendAnalyticsTabNavigationEvent = (tab) =>
  analyticsV4({
    levels: getLevels('tabs'),
    eventName: AnalyticsEvents.tabNavigation,
    options: { additional_info: [tab] },
  });

/**
 * Sends an analytics event for file upload.
 *
 * @param {string} tab - The source tab from which the upload event is triggered.
 * @param {Object} [options={}] - Advanced control options for the upload event.
 * @param {string} [options.publicId] - User defined public ID.
 * @param {Array<string>} [options.tags] - User defined tags.
 * @param {string} [options.preset] - User defined preset.
 */
export const sendAnalyticsUploadEvent = (tab, options = {}) =>
  analyticsV4({
    levels: getLevels(`tab-${tab}`),
    eventName: AnalyticsEvents.upload,
    options: {
      additional_info: [`publicId:${Boolean(options.publicId)}`, `tags:${Boolean(options.tags?.length)}`, `preset:${Boolean(options.preset)}`],
    },
  });
